import { Command, API_PREFIX, API_VERSION, HttpVerbType } from "../Command";
import { SaveInstallationsScheduleConfigurationRequestData } from "./SaveInstallationsScheduleConfigurationRequestData";
import { ServiceResponseData } from "../ServiceResponseData";

const ENDPOINT = "/schedules/create";

export class SaveInstallationsScheduleConfigurationCommand extends Command {
  endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
  httpVerb: HttpVerbType = "post";
  payload: SaveInstallationsScheduleConfigurationRequestData;

  constructor(payload: SaveInstallationsScheduleConfigurationRequestData) {
    super();
    this.payload = payload;
  }

  public async execute(): Promise<ServiceResponseData> {
    var res = await this.executeCommand(this.payload);
    return new ServiceResponseData(res);
  }
}
